import React from "react"
import Contact from "@views/contact"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Contact Us"
      keywords={[
        `engineid`,
        `security`,
        `access to your applications`,
        `password management`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <Contact />
  </div>
)

export default IndexPage
